import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';

function ProfileForm() {
   const [isLoading, setIsLoading] = useState(true);
   const [message, setMessage] = useState(""); 
   const email_id= sessionStorage.getItem("userEmail"); 
   const userName = sessionStorage.getItem("userName");
   const user_id = sessionStorage.getItem("user_id");
   const [messageType, setMessageType] = useState(""); 

   sessionStorage.removeItem("parentPage");

   function handleForgotPassword() {
    var data = {
        "email_id": email_id, 
        "platform_type": "web",
        "redirect_url": "https://subscription-portal-7004959657.development.catalystserverless.com.au"
    };

    var userManagement = window.catalyst.userManagement;
    var forgotPromise = userManagement.forgotPassword(data);

    forgotPromise
        .then((response) => {

            if (response.status === 200) {
              setMessage(response.content);
              setMessageType("success");
          } else {
              setMessage(response.message || "Failed to send reset link.");
              setMessageType("error");
          }

            setTimeout(()=>{
              setMessage("")
            },5000);
        })
        .catch((err) => {
            console.error("Error:", err);
            setMessage("Failed to send reset link. Please try again."); 

            setTimeout(()=>{
              setMessage("")
            },5000);
        });
}

setTimeout(() => {
  setIsLoading(false)
},3000);
  return (
    <div className="bg-[#F7F7F7] -m-[23px] p-[30px] min-h-screen pl-[45px] pr-[45px] flex flex-col ">
      {/* Heading */}
      {isLoading && (
        <div className="absolute inset-0 flex h-90vh justify-center items-center bg-white bg-opacity-75 z-50">
          <div className="animate-spin w-12 h-12 border-[4px] rounded-full border-l-[#095856] border-black"></div>
        </div>
      )}
       <nav class="flex" aria-label="Breadcrumb">
              <ol class="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                <li class="inline-flex items-center">
                 <Link
                    to="/profile"
                    className="ms-1 text-[14px] text-gray-400  md:ms-2 dark:text-gray-400 hover:text-[#0E5C57]"
                  >Account Settings
                    </Link>
                </li>
                <li>
                  <div class="flex items-center">
                    <svg class="rtl:rotate-180 w-2.5 h-2.5 text-gray-400 mx-1 text-[14px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 6 10">
                      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 9 4-4-4-4"/>
                    </svg>
                    <Link
                      to="/donationDetails"
                      className="ms-1 text-[14px] text-gray-400 md:ms-2 dark:text-gray-400 dark:hover:text-white"
                    >{user_id}
                      </Link>
            
                  </div>
                </li>
              </ol>
            </nav>
      <div className="flex flex-col mb-4">
        <h5 className="font-Jost text-[28px] mt-5 font-medium leading-[36.4px] mb-2">{userName}</h5>
      </div>
      <div className="flex-1 overflow-y-auto max-h-[calc(100vh-150px)] scrollbar">
      <div className="flex flex-col gap-[18px]  max-sm:gap-[20px]">
            <div  className="flex flex-row justify-center  items-center max-sm:flex-col max-sm:justify-start max-sm:items-start max-sm:block">
                <div className="bg-white rounded-[8px] border-[1px] border-[#0000001A] w-[100%] p-[40px] pr-[32px] pl-[25px]  shadow-none max-sm:w-[auto] max-sm:h-[auto] max-sm:p-[20px]">
                <div className="flex flex-col gap-[20px] max-sm:flex-col max-sm:gap-[20px]">

                <div className="flex flex-row justify-between max-sm:flex-col gap-[8px]">
                  <p className="font-Jost flex-1 text-[16px] font-medium text-[#545454] cursor-pointer line-clamp-1-5">
                  Username
                  </p>
                  <p className='flex-4 text-[16px] text-[#545454]  font-Jost text-sm'>
                    {email_id}
                  </p>
                </div>

                <div className="flex  flex-row justify-between max-sm:flex-col gap-[8px]">
                  <p className="text-[#545454] flex-1 font-Jost text-[16px] font-medium">
                  Password
                    </p>
                  <p className="flex-4 text-[16px] text-[#0E5C57] font-medium font-Jost text-sm cursor-pointer hover:underline"
                  //  onClick="handleForgotPassword()"
                   onClick={() => handleForgotPassword()}
                   >
                    Change Password
                  </p>
                </div>
                {message && (
                    <p className="text-[14px] italic opacity-.9 text-[#0E5C57] font-medium  flex justify-center mr-[50%] max-sm:mr-0">{message}</p>
                  )}
              </div>
            </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileForm;
